import { gql, useMutation } from '@apollo/client';

import { GET_EMPLOYEE_BY_ID } from './get-employee-by-id.hook';

export const PARTIAL_EMPLOYEE_UPDATE = gql`
  mutation partialMemberUpdate($payload: PartialMemberUpdateInput!) {
    partialMemberUpdate(payload: $payload) {
      _id
    }
  }
`;

export const usePartialEmployeeUpdate = ({ onSuccess }: { onSuccess?: () => void }) => {
  const [partialEmployeeUpdate] = useMutation(PARTIAL_EMPLOYEE_UPDATE, {
    onCompleted: data => {
      if (onSuccess && data) {
        onSuccess();
      }
    },
    refetchQueries: [GET_EMPLOYEE_BY_ID],
  });

  return partialEmployeeUpdate;
};
